import { PaymentProduct } from "src/models/payment";
import { createEntityModel } from "src/store/models/entity/_shared";

export const PaymentProductEntityModel = createEntityModel<PaymentProduct>();
